export const institutionAdminDisplayName = (profile, fallback = 'Admin') => {
  if (!profile) return fallback;
  return [profile.name, profile.surname].filter(Boolean).join(' ').trim()
    || profile.username
    || fallback;
};

export const buildInstitutionAdminCandidates = ({
  members = [],
  adminProfileIds = [],
  ownerProfileId = '',
  search = '',
  limit = 20,
} = {}) => {
  const excludedIds = new Set([ownerProfileId, ...adminProfileIds].filter(Boolean));
  const query = String(search || '').trim().toLowerCase();
  const seen = new Set();

  return members
    .filter(member => {
      const profileId = member?.id || member?.profile_id;
      if (!profileId || member?.is_demo_profile || excludedIds.has(profileId) || seen.has(profileId)) return false;
      seen.add(profileId);
      if (!query) return true;
      return [member.name, member.username, member.association_type]
        .filter(Boolean)
        .some(value => String(value).toLowerCase().includes(query));
    })
    .slice(0, limit);
};
